import client from "../api/client";
export const getList = () => {
  return client('/api/user-groups').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/user-groups/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/user-groups/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/user-groups', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/user-groups/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useUserGroupService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
